import React, { useEffect, useState } from 'react';
export const CountdownBar = () => {
  const [timeLeft, setTimeLeft] = useState(23 * 3600); // 23 hours in seconds
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    const storedTime = localStorage.getItem('rugby_countdown');
    if (storedTime) {
      setTimeLeft(parseInt(storedTime, 10));
    } else {
      localStorage.setItem('rugby_countdown', (23 * 3600).toString());
    }
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 0;
        const newTime = prev - 1;
        localStorage.setItem('rugby_countdown', newTime.toString());
        return newTime;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  if (!mounted) return null;
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="bg-rugby-blue text-white text-center py-3 px-4 sticky top-0 z-50 font-sans font-bold text-sm md:text-base flex flex-col md:flex-row items-center justify-center gap-2 shadow-lg" data-id="element-149">
      <span className="uppercase tracking-wide" data-id="element-150">
        ¡ATENCIÓN! Esta oferta termina en:
      </span>
      <div className="flex items-center gap-1 bg-white text-rugby-blue px-3 py-1 rounded shadow-inner" data-id="element-151">
        <span className="w-6 text-center" data-id="element-152">
          {hours.toString().padStart(2, '0')}
        </span>
        <span data-id="element-153">:</span>
        <span className="w-6 text-center" data-id="element-154">
          {minutes.toString().padStart(2, '0')}
        </span>
        <span data-id="element-155">:</span>
        <span className="w-6 text-center" data-id="element-156">
          {seconds.toString().padStart(2, '0')}
        </span>
      </div>
    </div>;
};